export default __webpack_public_path__ + "static/horsing-0f199a252f0394e452522e4750f52ca0.svg";